<template>
  <!-- eslint-disable max-len -->
  <BaseFetchData ref="emailMessageList" :action="fetchData">
    <!-- props
      fetchData, status.loading, status.resolved, status.rejected, rejectReason
    -->
    <template #default="fetchDataProps">
      <ul v-if="fetchDataProps.status.resolved" role="list" class="divide-y divide-gray-200">
        <EmailMessageListItem
          v-for="emailMessage in emailMessages"
          :key="emailMessage.id"
          :focused="currentEmailMessage && emailMessage.id === currentEmailMessage.id"
          :email-message="emailMessage"
          @email-message:focus="handleEmailMessageFocus"
          @email-message:edit="handleEmailMessageEdit"
          @email-message:delete="handleEmailMessageDelete"
        />
      </ul>
    </template>
  </BaseFetchData>
</template>

<script>
import { pipelineStageEmailMessagesClient } from '@/api/clients';
import EmailMessageListItem from './EmailMessageListItem.vue';

export default {
  components: {
    EmailMessageListItem,
  },
  props: {
    currentEmailMessage: {
      type: Object,
      default: () => null,
    },
    pipelineStageId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      emailMessages: [],
    };
  },
  methods: {
    handleEmailMessageFocus(emailMessage) {
      this.$emit('email-message:focus', emailMessage);
    },
    handleEmailMessageEdit(emailMessage) {
      this.$modal.show({
        component: () =>
          import(
            '@/components/PipelineStageEmailMessage/WriteEmailMessageDialog/WriteEmailMessageDialog.vue'
          ),
        props: {
          accountId: emailMessage.account_id,
          pipelineStageId: this.pipelineStageId,
          emailMessageId: emailMessage.id,
        },
        on: {
          saved: () => {
            this.$refs.emailMessageList.fetchData();
          },
        },
        hideEvent: 'close',
      });
    },
    handleEmailMessageDelete(emailMessage) {
      this.$modal.show({
        component: () =>
          import(
            '@/components/PipelineStageEmailMessage/DeleteEmailMessageDialog/DeleteEmailMessageDialog.vue'
          ),
        props: {
          action: async (emailMessageId) => {
            try {
              await pipelineStageEmailMessagesClient.destroy(this.pipelineStageId, emailMessageId);

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          emailMessage,
        },
        on: {
          deleted: () => {
            this.$refs.emailMessageList.fetchData();
          },
        },
        hideEvent: 'close',
      });
    },
    fetchData() {
      return pipelineStageEmailMessagesClient
        .list(this.pipelineStageId, {
          include: 'user,tracking_logs_count',
          sort: '-created_at',
        })
        .then((response) => {
          this.emailMessages = response.data;

          return Promise.resolve(response);
        })
        .finally(() => {
          this.handleEmailMessageFocus(this.emailMessages?.[0] || null);
        });
    },
  },
};
</script>
